(function () {
  if (window.__bbQuizInit) return;
  window.__bbQuizInit = true;

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function sizedImg(url, w) { if (!url) return ''; var join = url.indexOf('?') > -1 ? '&' : '?'; return url + join + 'width=' + w; }
  function firstAvailableVariant(p) { for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; } return p.variants[0]; }
  function esc(s) { return (s || '').replace(/"/g, '&quot;'); }
  function cardTitleOf(p) {
    var t = p.title || '';
    if (p.vendor && t.indexOf(p.vendor) === 0) { t = t.slice(p.vendor.length).replace(/^[\s–—:-]+/, ''); }
    return t;
  }

  // ---- standard product card (same markup as the all-products grid) ----
  function cardHTML(p) {
    var v = firstAvailableVariant(p);
    var img = sizedImg(p.featured_image, 480);
    var title = esc(p.title);
    var cardTitle = cardTitleOf(p);
    var add;
    if (!v || !v.available) {
      add = '<span class="shop-card__soldout">Sold out</span>';
    } else if (p.variants.length === 1) {
      add = '<form method="post" action="/cart/add" class="shop-card__form" data-cart-add>' +
          '<input type="hidden" name="id" value="' + v.id + '">' +
          '<button type="submit" class="shop-card__add" aria-label="Add ' + title + ' to bag">+</button>' +
        '</form>';
    } else {
      add = '<a class="shop-card__add shop-card__add--opt" href="' + p.url + '" aria-label="Choose options for ' + title + '">+</a>';
    }
    var heart = '<button type="button" class="shop-card__wish" aria-label="Save for later">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20.5S4 15.4 4 9.9C4 7.2 6 5.3 8.5 5.3c1.6 0 3 .9 3.5 2.2.5-1.3 1.9-2.2 3.5-2.2C18 5.3 20 7.2 20 9.9c0 5.5-8 10.6-8 10.6z"/></svg>' +
      '</button>';
    return '<article class="shop-card">' +
        '<a class="shop-card__media" href="' + p.url + '" aria-label="' + title + '">' +
          heart +
          (img ? '<img class="shop-card__img shop-card__img--primary" src="' + img + '" alt="' + title + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="shop-card__body">' +
          (p.vendor ? '<p class="shop-card__vendor">' + p.vendor + '</p>' : '') +
          '<h3 class="shop-card__title"><a href="' + p.url + '">' + cardTitle + '</a></h3>' +
          '<div class="shop-card__foot">' +
            '<p class="shop-card__price">' + money(v ? v.price : p.price) + '</p>' +
            add +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function renderCards(container, handles, seen) {
    container.innerHTML = '';
    seen = seen || {};
    return Promise.all(handles.map(fetchProduct)).then(function (products) {
      var count = 0;
      products.forEach(function (p) {
        if (!p || seen[p.id]) return;
        seen[p.id] = true;
        container.insertAdjacentHTML('beforeend', cardHTML(p));
        count++;
      });
      return count;
    });
  }

  // ---- routine builder (build-me-one path) ----
  // Roles come from the product TYPE/title/handle (not ingredients): deterministic.
  function rolesFor(p) {
    var s = ((p.type || '') + ' ' + (p.title || '') + ' ' + (p.handle || '')).toLowerCase();
    var roles = [];
    var isKit = /\bkit\b|\bduo\b|\bsystem\b/.test(s) || /shampoo[\s\S]*conditioner|conditioner[\s\S]*shampoo/.test(s);
    if (isKit) { roles.push('cleanse', 'condition'); }
    if (roles.indexOf('cleanse') < 0 && /shampoo/.test(s)) roles.push('cleanse');
    if (roles.indexOf('condition') < 0 && /conditioner|co-?wash/.test(s)) roles.push('condition');
    if (/\bmask\b|masque/.test(s)) roles.push('mask');
    if (/leave-?in/.test(s)) roles.push('leavein');
    if (/\boil\b/.test(s)) roles.push('oil');
    if (!roles.length && /balm|thermoliss|nanoplast|reconstru|keratin|\bcream\b|3-?in-?1/.test(s)) roles.push('treatment');
    if (!roles.length) roles.push('treatment');
    return roles;
  }
  var ROLE_ORDER = ['cleanse', 'condition', 'mask', 'leavein', 'treatment', 'oil'];
  var ROLE_LABEL = { cleanse: 'Cleanse', condition: 'Condition', mask: 'Mask', leavein: 'Leave-in', treatment: 'Treat', oil: 'Oil' };
  function freqFor(role, wash) {
    var w = { daily: 'daily', alt: 'every other day', '2-3': '2–3 times a week' }[wash] || '2–3 times a week';
    switch (role) {
      case 'cleanse': return 'Wash ' + w + '.';
      case 'condition': return 'Every time you wash.';
      case 'mask': return 'Once a week, instead of conditioner.';
      case 'leavein': return 'Every wash, on damp hair.';
      case 'treatment': return 'As needed, on damp hair.';
      case 'oil': return 'About twice a week, on your ends.';
      default: return '';
    }
  }
  function buildRoutine(handles) {
    return Promise.all(handles.map(fetchProduct)).then(function (products) {
      var byRole = {};
      products.filter(Boolean).forEach(function (p) {
        rolesFor(p).forEach(function (r) { if (!byRole[r]) byRole[r] = p; });
      });
      // one step per product: a kit that fills two roles is merged, not repeated.
      var steps = [], byId = {};
      ROLE_ORDER.forEach(function (r) {
        var p = byRole[r]; if (!p) return;
        if (byId[p.id]) { byId[p.id].roles.push(r); return; }
        var step = { product: p, roles: [r] };
        byId[p.id] = step; steps.push(step);
      });
      return steps;
    });
  }
  function routineStepHTML(step, idx, wash) {
    var p = step.product, v = firstAvailableVariant(p);
    var img = sizedImg(p.featured_image, 240);
    var t = esc(cardTitleOf(p));
    var soldout = !(v && v.available);
    var primary = step.roles[0];
    var roleLabel = step.roles.map(function (r) { return ROLE_LABEL[r]; }).join(' &amp; ');
    return '<li class="bb-quiz__rstep">' +
      '<span class="bb-quiz__rnum">' + (idx + 1) + '</span>' +
      '<a class="bb-quiz__rmedia" href="' + p.url + '" aria-label="' + t + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="bb-quiz__rbody">' +
        '<p class="bb-quiz__rrole">' + roleLabel + '</p>' +
        '<h4 class="bb-quiz__rtitle"><a href="' + p.url + '">' + cardTitleOf(p) + '</a></h4>' +
        '<p class="bb-quiz__rfreq">' + freqFor(primary, wash) + '</p>' +
      '</div>' +
      '<span class="bb-quiz__rprice">' + money(v ? v.price : p.price) + (soldout ? ' · sold out' : '') + '</span>' +
    '</li>';
  }
  function addAllHTML(steps) {
    var inputs = '', total = 0, i = 0;
    steps.forEach(function (s) {
      var v = firstAvailableVariant(s.product);
      if (!v || !v.available) return;
      inputs += '<input type="hidden" name="items[' + i + '][id]" value="' + v.id + '"><input type="hidden" name="items[' + i + '][quantity]" value="1">';
      total += v.price; i++;
    });
    if (!i) return '';
    return '<form method="post" action="/cart/add" class="bb-quiz__addall">' +
      '<input type="hidden" name="return_to" value="/checkout">' + inputs +
      '<button type="submit" class="film-cta film-cta--solid">Add all to bag · ' + money(total) + '</button></form>';
  }

  function initQuiz(root) {
    var buckets;
    try { buckets = JSON.parse(root.getAttribute('data-buckets')); } catch (e) { buckets = {}; }
    var stepEls = {};
    root.querySelectorAll('[data-step]').forEach(function (el) { stepEls[el.getAttribute('data-step')] = el; });
    var result = root.querySelector('[data-result]');
    var gridWrap = result.querySelector('[data-result-grid]');
    var routineWrap = result.querySelector('[data-result-routine]');
    var heroesEl = result.querySelector('[data-heroes]');
    var alsoEl = result.querySelector('[data-also]');
    var alsoLabel = result.querySelector('[data-also-label]');
    var routineList = result.querySelector('[data-routine-list]');
    var routineActions = result.querySelector('[data-routine-actions]');
    var state = { routine: null, hair: null, goal: null, wash: null };

    function show(el, on) { if (el) el.hidden = !on; }
    function split(s) { return (s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
    function hideSteps() { Object.keys(stepEls).forEach(function (k) { show(stepEls[k], false); }); }
    function goto(name) { Object.keys(stepEls).forEach(function (k) { show(stepEls[k], k === name); }); show(result, false); }
    function handlesFor(goal) { var b = buckets[goal] || { heroes: '', also: '' }; return { heroes: split(b.heroes), also: split(b.also) }; }

    function showGrid() {
      var h = handlesFor(state.goal);
      hideSteps(); show(result, true); show(gridWrap, true); show(routineWrap, false);
      heroesEl.innerHTML = ''; alsoEl.innerHTML = ''; show(alsoLabel, false);
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var gseen = {}; // shared so a product in both lists shows only once (in heroes)
      renderCards(heroesEl, h.heroes, gseen);
      if (h.also.length) renderCards(alsoEl, h.also, gseen).then(function (n) { show(alsoLabel, n > 0); });
    }
    function showRoutine() {
      var h = handlesFor(state.goal);
      hideSteps(); show(result, true); show(gridWrap, false); show(routineWrap, true);
      routineList.innerHTML = ''; routineActions.innerHTML = '';
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      buildRoutine(h.heroes.concat(h.also)).then(function (steps) {
        routineList.innerHTML = steps.map(function (s, i) { return routineStepHTML(s, i, state.wash); }).join('');
        routineActions.innerHTML = addAllHTML(steps);
      });
    }

    function setActive(btn) {
      var p = btn.parentNode;
      if (p) p.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    }
    function restart() {
      state = { routine: null, hair: null, goal: null, wash: null };
      root.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); });
      goto('routine');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-routine')) { setActive(t); state.routine = t.getAttribute('data-routine'); goto('hair'); }
      else if (t.hasAttribute('data-hair')) { setActive(t); state.hair = t.getAttribute('data-hair'); goto('goal'); }
      else if (t.hasAttribute('data-goal')) { setActive(t); state.goal = t.getAttribute('data-goal'); if (state.routine === 'no') { goto('wash'); } else { showGrid(); } }
      else if (t.hasAttribute('data-wash')) { setActive(t); state.wash = t.getAttribute('data-wash'); showRoutine(); }
      else if (t.hasAttribute('data-back')) { goto(t.getAttribute('data-back')); }
      else if (t.hasAttribute('data-restart')) { restart(); }
    });
    // product "+" adds and the routine "Add all" form post are native / handled by the cart island.
  }

  function boot() { document.querySelectorAll('[data-bb-quiz]').forEach(initQuiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
